import DealSVG from "./svg/deals.svg?react";

const DealBadge = ({ style, className = "", ...props }) => (
  <span className={`record-badge deals ${className}`} style={style} aria-hidden="true">
    <DealSVG {...props} />
  </span>
);

export default DealBadge;
